import React from 'react';
import { styles } from "./styles";
import { cn } from "../../../helpers";
export function GridSelectionSubheader(_a) {
    var selected = _a.selected, total = _a.total;
    return (React.createElement("div", { className: styles.subheader },
        React.createElement("div", { className: styles.textTitle },
            "Selected:",
            React.createElement("span", { className: styles.textValue },
                React.createElement("span", { className: cn(!!selected && styles.textSelectedCount) }, selected || 0),
                ' ',
                "of ",
                total || 0))));
}
//# sourceMappingURL=GridSelectionSubheader.js.map